// @ts-nocheck

import palette from '../palette';

import { withOpacity } from './helpers';

export const Countdown = {
  timerColor: palette.black,
  timerBgColor: withOpacity(palette.white, 'dd'),
  timerBorderColor: withOpacity(palette.white, 'aa'),
  timerBorderColorWarning: withOpacity(palette.red100, 'aa'),
  clockColorDistribution: {
    step1: palette.greenwinamax450,
    step2: palette.yellowwinamax450,
    step3: palette.red200,
  },
};
